const PolicyHolderClaimantData = ({
  Document,
  PolicyHolder,
}) => ({
  document: Document ?? '',
  policyHolder: PolicyHolder ?? '',
})

export default PolicyHolderClaimantData
